import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ExamCircularTimerComponent } from './exam-circular-timer/exam-circular-timer.component';
import { ExamCriteriaListComponent } from './exam-criteria-list/exam-criteria-list.component';
import { ExamAdviceCardComponent } from './exam-advice-card/exam-advice-card.component';
import { ExamAssistantRailComponent } from './exam-assistant-rail/exam-assistant-rail.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'lib-exam-assistant-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    ExamCircularTimerComponent,
    ExamCriteriaListComponent,
    ExamAdviceCardComponent,
    ExamAssistantRailComponent,
  ],
  templateUrl: './exam-assistant-panel.component.html',
  styleUrls: ['./exam-assistant-panel.component.scss'],
})
export class ExamAssistantPanelComponent {
  // --- Inputs ---
  activityLabel = input<string>('');
  remainingSeconds = input.required<number>();
  totalSeconds = input.required<number>();
  evaluationCriteria = input<string>('');
  advice = input<string | null>(null);
  isReformulating = input<boolean>(false);
  ttsPlaying = input<boolean>(false);
  consigneText = input<string>('');
  testLanguage = input<string>('');
  showTimer = input<boolean>(true);
  collapsed = input<boolean>(false);
  abandonDisabled = input<boolean>(false);
  showAbandon = input<boolean>(true);
  muteTimerAlarm = input<boolean>(false);

  // --- Outputs ---
  reformulate = output<void>();
  toggleTts = output<void>();
  collapsedChange = output<boolean>();
  abandonTest = output<void>();
  openDeviceSettings = output<void>();

  // --- Méthodes template ---
  collapse(): void {
    this.collapsedChange.emit(true);
  }

  expand(): void {
    this.collapsedChange.emit(false);
  }
}
